'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Avatar": "Polaris-Avatar",
  "imageHasLoaded": "Polaris-Avatar--imageHasLoaded",
  "Text": "Polaris-Avatar__Text",
  "long": "Polaris-Avatar--long",
  "hidden": "Polaris-Avatar--hidden",
  "sizeXs": "Polaris-Avatar--sizeXs",
  "sizeSm": "Polaris-Avatar--sizeSm",
  "sizeMd": "Polaris-Avatar--sizeMd",
  "sizeLg": "Polaris-Avatar--sizeLg",
  "sizeXl": "Polaris-Avatar--sizeXl",
  "styleOne": "Polaris-Avatar--styleOne",
  "styleTwo": "Polaris-Avatar--styleTwo",
  "styleThree": "Polaris-Avatar--styleThree",
  "styleFour": "Polaris-Avatar--styleFour",
  "styleFive": "Polaris-Avatar--styleFive",
  "styleSix": "Polaris-Avatar--styleSix",
  "styleSeven": "Polaris-Avatar--styleSeven",
  "Image": "Polaris-Avatar__Image",
  "Initials": "Polaris-Avatar__Initials",
  "Svg": "Polaris-Avatar__Svg"
};

exports.default = styles;
